import React, { Component } from "react";
import { DetailsDashboard } from "../../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import { MODAL_CUSTOM_MESSAGE, Selected_Index, TABLE_PAGINATION_KEY, VAT_GROUP } from "../../../../../constants/external-constants";
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
import ModalContainer from "../../../../common/modal/modal-container/modal-container.component";
import DetailContainer from "../../../../common/Layout/details/DetailsLayout.component";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import DebitorDetailForm from "../modal-form/details/form/debitor-detail-form.component";
import DebitorCatalogueHistory from "../modal-form/history/debitor-catalogue-history.component";
import { isObjectEqual } from "../../../../../utils/helpers.utils";
import { debitorCatalogueActions } from "../../../../../store/external/recharge-reducer/debitor-catalogue-reducer/debitor-catalogue.reducer";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { TRANSLATIONS as translation } from "../../../../../utils/constant.utils";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { convertToDecimal, checkVatPercentValue, checkCountryCodeFormat, validateAccessModule } from "../../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";

class DebitorCatalogueTable extends Component {
    constructor(props) {
        super(props);
        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            detailsView: false,
            debitorId: 0,
            userId: 0,
            showModal: false,
            showModalForm: false,
            isNew: false,
            isSaving: false,
            debitorAlreadyExist: false,
            percentExceed: false,
            activeTab: Selected_Index.i_Zero,
            contentIndex:  Selected_Index.i_Zero,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            confirmationModal: {
                title: "",
                messageBody: "",
                confirmAction: () => {}
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
        }
        this.ConfirmationModal = React.createRef();
    }

    componentDidMount() {
        this.getDebitorCatalogueDetails();
    }

    componentWillUnmount() {
        this.props.setDefaultDebitorCatalogue();
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractDebitorCatalogue();
        }
    };

    displaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    resizePage = (value) => {
        const { getDebitorCatalogue, resizeDebitorCataloguePage } = this.props;
        resizeDebitorCataloguePage(value);
        getDebitorCatalogue();
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    applyFilter = (isApply) => {
        const { getDebitorCatalogue, applyDebitorCatalogueFilter } = this.props;
        applyDebitorCatalogueFilter(isApply);
        getDebitorCatalogue(0);
    }

    handleRowClick = (data) => {
        const { debitorCatalogueForm, getDebitorCatalogueForm, getCountriesList, getSelectedSalesOrg,  getDebitorSalesOrganizationList, } = this.props;

        getDebitorCatalogueForm(data).then( async() =>{
            
        });

        getCountriesList(1, data?.Country).then( async () =>{
                this.setState({
                showModalForm: true,
                debitorId: data.debitorId,
                debitorAlreadyExist: false,
                percentExceed: false,
                });
        })
       
    }

    handleSelectedIndex = (index) =>{
        this.setState({
            contentIndex: index,
            debitorAlreadyExist: false,
            percentExceed: false,
        })
    }

    getDebitorCatalogueDetails(){
        const { getDebitorCatalogue, getDebitorCatalogueDropdownList, getCountriesList } = this.props
        getDebitorCatalogue();
        getDebitorCatalogueDropdownList();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
        return translation[locale][key];
    }

    handleCreateNewAction=()=>{
        this.setState({
            showModal: true,
            debitorAlreadyExist: false,
            percentExceed: false,
        })   
    }

    handleCreateNewConf(buttonType){
        const { getDebitorCatalogueForm, getCountriesList } = this.props;
        if(buttonType==="ok")
        {
            getDebitorCatalogueForm();
            getCountriesList();
            this.setState({
                showModalForm: true,
                showModal: false,
                isNew: true
            }) 
        } else {
            this.setState({showModal: false })
        }
     }

    handleCloseFormModal = () => {
        this.setState({ showModalForm: false, contentIndex: Selected_Index.i_Zero, isNew: false })
    }

    onClickSaveModal = async (debitorId, validate = 1) => {
        const { saveDebitorCatalogueForm, debitorCatalogueForm, getDebitorCatalogue } = this.props;
        const { isNew } = this.state;
        
        var isVatPercentValueValid = checkVatPercentValue(debitorCatalogueForm.vatPercent, debitorCatalogueForm.vatGroupId);
        var isValidCountryCodeFormat = checkCountryCodeFormat(debitorCatalogueForm.countryCode);

        if(!isVatPercentValueValid){
            if(debitorCatalogueForm.vatPercent > convertToDecimal(100.00)){
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), this.toLocaleLanguage("vat_percent_exceed"));
                this.setState({
                    percentExceed: true
                })
                return;
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), this.toLocaleLanguage("vat_percent_required"));
                this.setState({
                    percentExceed: true
                })
                return;
            }
        } else {
            this.setState({
                percentExceed: false
            })
        }

        if(!isValidCountryCodeFormat){
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), this.toLocaleLanguage("country_code_invalid"));
            return;
        }

        this.setState({
            isSaving: true
        });

        var result = await saveDebitorCatalogueForm(debitorId, validate);
        this.setState({
            isSaving: false
        });

        if(result.success)
        {
            if(result.isValid)
            {
                if (!isNew) {
                    const confirmMessage = "Are you sure you want to save?";
                    const modalTitle = this.toLocaleLanguage("call_save", false);
                    var confirmAction = () => this.onClickSaveModal(debitorCatalogueForm.debitorId, 0)
                    this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                    return;
                }
                else {
                    this.onClickSaveModal(debitorCatalogueForm.debitorId, 0)
                    return;
                }
            }
            else{
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), result.message);
                getDebitorCatalogue();
                this.handleCloseFormModal();
                return;
            }
        }
        else
        {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
            if(result.message === "Debitor Number already exist") {
                this.setState({
                    debitorAlreadyExist:true
                })
            }
            return;
        }
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    setPercentExceed = (value) => {
        this.setState({ percentExceed: value });
    };

    render() {
        const { contentIndex, activeTab, showModalForm, isNew, debitorAlreadyExist, percentExceed } = this.state;
        const { 
                sortDebitorCatalogueItems, 
                addDebitorCatalogueFilter, 
                removeDebitorCatalogueFilter,
                setDebitorCatalogueColSearchStr,
                getDebitorCatalogue,
                debitorCatalogue, 
                debitorCatalogueForm,
                saveDebitorCatalogueCustomCols,
                $form 
            } = this.props;
        const { Selected, Available, Default } = this.props.debitorCatalogue.debitorCatalogueItems.Columns;
        const initialRequired = debitorCatalogueForm?.debitorNumber == '' 
            || debitorCatalogueForm?.debitorName == '' 
            || debitorCatalogueForm?.countryId == 0 
            || debitorCatalogueForm?.currencyId == 0
            || debitorCatalogueForm?.salesOrganizationId == 0
            || debitorCatalogueForm?.vatGroupId == 0;

        const disableSaveChanges = isObjectEqual($form.value, debitorCatalogueForm) ? true : false;   

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingDebitorCatalogueDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingDebitorCatalogueDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingDebitorCatalogueDashboardRW])
        return (
            <>
                <DetailsDashboard 
                    // Filter Propertiess
                    data={debitorCatalogue.debitorCatalogueItems.TableFilterData} 
                    translation={""} 
                    addAction={addDebitorCatalogueFilter} 
                    removeAction={removeDebitorCatalogueFilter} 
                    applyAction={this.applyFilter}
                    isCreateButtonHidden={!debitorCatalogue.isDebitorCatalogueLoaded}
                    customClassName={"debitor-catalogue"}
                    //Create New
                    createNewAction={this.handleCreateNewAction}

                    //View Search Textbox
                    viewSearchAction={this.displaySearchBox}

                    //Customize Column
                    firstList={Available}
                    secondList={Selected}
                    defaultList={Default}
                    saveAction={saveDebitorCatalogueCustomCols}

                    //Extract Button
                    extractAction={(e) => this.onClickExtract(e)}

                    //Access Type
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                >
                    {
                        debitorCatalogue.isDebitorCatalogueLoaded ?
                        <TablePagination  
                            key={TABLE_PAGINATION_KEY.debitorCatalogue}
                            classNameWrapper="overflow-auto"
                            columns={debitorCatalogue.debitorCatalogueItems.Headers}
                            pageList={debitorCatalogue.debitorCatalogueItems.Data}
                            pages={debitorCatalogue.debitorCatalogueItems.Pagination}
                            rowClickAction={(item) => {this.handleRowClick(item)}}
                            paginationAction={getDebitorCatalogue} 
                            onColumnClick={sortDebitorCatalogueItems} 
                            onColumnSearch={() => { getDebitorCatalogue(0) }} 
                            onColumnSearchChange={setDebitorCatalogueColSearchStr} 
                            isColSearchShow={this.state.displaySearch}
                            resizePage={this.resizePage}
                            totalPage={debitorCatalogue.debitorCatalogueItems.Pagination.TotalEntries}
                            hideStatusIcon={true}
                        />
                    : this.loading()}
                </DetailsDashboard>


                <ConfirmationNotificationModal 
                    show={this.state.showModal} 
                    message={MODAL_CUSTOM_MESSAGE.create_new_debitor} 
                    title={'Add New'}
                    handleModal={this.handleCreateNewConf.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <ModalContainer
                    title="debitor_info"
                    show={showModalForm}
                    handleModal={this.handleCloseFormModal}
                    hideBtn={contentIndex === Selected_Index.i_One || !debitorCatalogue.isFetchFormLoaded  ? true : false}
                    saveDetails={this.onClickSaveModal}
                    customClass="cost-allocation-details__modal modal-form__container"
                    disabled={this.state.isNew ? initialRequired : disableSaveChanges}
                    isReadAndWrite={isReadAndWrite}
                    primaryBtnTooltip={"save_debitor_info"}
                >

                <div className="data-table">
                    <DetailContainer
                        renderTabContent={this.handleSelectedIndex}
                        urlIndex={activeTab}
                        listTab={[
                            {
                                "id": Selected_Index.i_Zero,
                                "label": "Details",
                                "hidden": false
                            },
                            {
                                "id": Selected_Index.i_One,
                                "label": "History",
                                "hidden": false,
                                "disable": isNew ? true : false
                            },

                        ]}
                    >
                            {contentIndex === Selected_Index.i_Zero &&
                                <DebitorDetailForm
                                    debitorId={debitorCatalogue.debitorCatalogueDetails.debitorId}
                                    debitorAlreadyExist={debitorAlreadyExist}
                                    percentExceed={percentExceed}
                                    setPercentExceed={this.setPercentExceed}
                                />
                            }
                            {contentIndex === Selected_Index.i_One &&
                                <DebitorCatalogueHistory
                                debitorId={debitorCatalogue.debitorCatalogueDetails.debitorId}
                                //Access Type
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                                />
                            }
                        
                    </DetailContainer>
                </div>

                </ModalContainer> 

                    <ConfirmationModal
                        ref={this.ConfirmationModal}
                        title={this.state.saveModal.title}
                        messageBody={this.state.saveModal.messageBody}
                        confirmAction={this.state.saveModal.confirmAction}
                        closeLabel={this.toLocaleLanguage("cancel_button")}
                        confirmLabel={this.toLocaleLanguage("yes_button")}
                        disabled={this.state.isSaving}
                    /> 

                <NotificationModal
                    show={this.state.saveNotif.show}
                    title={this.state.saveNotif.title}
                    message={this.state.saveNotif.message}
                    handleModal={() => this.toggleSaveNotif(false)}
                    customClass={'comment-notification-modal modal-text-bold notification-footer confirmation-blur-background'}
                />
                   
            </>
        );
    }
}

export default withRouter(connect(
    state => {
        const { debitorCatalogue,
                form:{ forms:{ debitorCatalogueForm:{ $form } } }
         } = state;
        const { debitorCatalogueForm } = state.form;
        return {
            debitorCatalogueForm
            , debitorCatalogue
            , translation
            , $form
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, debitorCatalogueActions),
        dispatch
    )
)(DebitorCatalogueTable));